function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoneyIcon = function SvgMoneyIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 25",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M.833 1C.373 1 0 1.373 0 1.833v23.334c0 .46.373.833.833.833h38.334c.46 0 .833-.373.833-.833V1.833c0-.46-.373-.833-.833-.833H.833z",
    transform: "translate(0 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.backgroundColor,
    d: "M1.667 24.333L38.333 24.333 38.333 2.667 1.667 2.667z",
    transform: "translate(0 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M8.333 7.667c.919 0 1.667.746 1.667 1.666C10 10.252 9.252 11 8.333 11c-.92 0-1.666-.748-1.666-1.667 0-.92.746-1.666 1.666-1.666zm11.667 0c3.217 0 5.833 2.615 5.833 5.833 0 3.217-2.616 5.833-5.833 5.833s-5.833-2.616-5.833-5.833c0-3.218 2.616-5.833 5.833-5.833zM31.667 16c.918 0 1.666.747 1.666 1.667 0 .918-.748 1.666-1.666 1.666-.92 0-1.667-.748-1.667-1.666 0-.92.747-1.667 1.667-1.667zM3.333 18.5c0 2.297 1.869 4.167 4.167 4.167h25c2.297 0 4.167-1.87 4.167-4.167v-10c0-2.298-1.87-4.167-4.167-4.167h-25c-2.298 0-4.167 1.869-4.167 4.167v10z",
    transform: "translate(0 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M20.185 13.037c1.02 0 1.852.832 1.852 1.852 0 .86-.593 1.58-1.389 1.786v.529c0 .255-.208.463-.463.463s-.463-.208-.463-.463v-.529c-.796-.206-1.389-.926-1.389-1.786 0-.256.208-.463.463-.463s.463.207.463.463c0 .51.415.926.926.926.51 0 .926-.416.926-.926s-.416-.926-.926-.926c-1.022 0-1.852-.832-1.852-1.852 0-.861.593-1.58 1.39-1.786v-.529c0-.255.207-.463.462-.463s.463.208.463.463v.529c.796.206 1.389.925 1.389 1.786 0 .256-.208.463-.463.463s-.463-.207-.463-.463c0-.51-.416-.926-.926-.926s-.926.416-.926.926.415.926.926.926z",
    transform: "translate(0 -1)"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoneyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money_icon.66a1d2e9.svg";
export { ForwardRef as ReactComponent };